import { Injectable } from '@angular/core';
import { Store, guid } from '@datorama/akita';

export interface SidebarPlanState {
	readonly activePhaseIndex: number;
}

@Injectable()
export class CoachingPlanStore extends Store<SidebarPlanState> {
	constructor() {
		super({ activePhaseIndex: 0 }, { name: `ui-sidebar-plan-${guid()}` });
	}
}
